import { Outlet } from 'react-router-dom';
import { Navbar } from './Navbar';

export const DashboardLayout = () => {
  return (
    <div className="min-h-screen bg-zinc-100 dark:bg-zinc-950">
      <Navbar />
      <main className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-8">
        <Outlet />
      </main>
    </div>
  );
};
